module.exports = __webpack_public_path__ + "img/71.b8f835b.png";